export default "__VITE_ASSET__f203a10d__"